<template>
  <div class="ml-table-container default-table">
    <el-table ref="ElTable" v-loading="loading" :data="table" :show-header="showHeader" :show-summary="showSummary" :summary-method="getSummaries" style="width: 100%">
      <slot name="columns"/>
    </el-table>
    <div class="ml-table-container__footer">
      <div>
        <slot name="footer"/>
      </div>
      <el-pagination
          :current-page.sync="pagination.page"
          :page-sizes="[5,10,20,100, 200, 300, 400]"
          :page-size="pagination.page_size"
          layout="total, sizes, prev, pager, next"
          :total="pagination.total"
          @current-change="eventPageChange"
          @size-change="eventSizeChange"
      />
    </div>
  </div>
</template>
<script>
import {getPageCommon} from "../../api/common";
import {numberFormat} from "@/utils";

export default {
  name: 'MlTable',
  props: {
    api: {
      type: Function,
      required: true
    },
    search: {
      type: Object,
      default() {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default() {
        return 20
      }
    },
    height: {
      type: [String, Boolean],
      default() {
        return 'calc(100% - 32px - 12px)'
      }
    },
    showHeader: {
      type: Boolean,
      default() {
        return true
      }
    },
    showSummary: Boolean
  },
  data() {
    return {
      loading: false,
      table: [],
      pagination: {
        page: 1,
        page_size: this.pageSize,
        total: 0
      }
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    interfaceGetSelection: function () {
      return this.$refs.ElTable.selection
    },
    eventSizeChange: function (page_size) {
      this.pagination.page_size = page_size
      this.handleSearch()
    },
    eventPageChange: function (page) {
      this.pagination.page = page
      this.getTable()
    },
    handleSearch: function () {
      this.pagination.page = 1
      this.getTable()
    },
    getTable: async function () {
      this.loading = true
      const {model: {data: list, total, current_page}} = await getPageCommon(this.api, this.getParam())
      setTimeout(() => {
        this.loading = false
      }, 80)
      this.table = list || []
      this.pagination.total = total
      this.pagination.page = current_page
    },
    getParam: function () {
      const params = {...{}, ...this.search}
      for (const paramsKey in params) {
        const value = params[paramsKey]
        if (value === '' || value === null) {
          delete params[paramsKey]
        }
      }
      return {...params, ...this.pagination}
    },
    //表格列累计
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 0) {
          return false
        }
        if (index === 0) {
          sums[index] = '合计:'
          return false
        }
        // console.log(`${index}）${column.property}`)
        if (['sales_volume', 'settlement_amount'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          const valMaxIdx = values.length - 1
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr, idx) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                switch (column.property) {
                  case 'settlement_amount':
                    if (idx === valMaxIdx){
                      return numberFormat(prev * 1 + curr * 1, 2)
                    } else {
                      return prev * 1 + curr * 1
                    }
                  default:
                    return prev * 1 + curr * 1
                }
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      return sums
    }
  }
}
</script>
<style lang="scss">
.ml-table-container {
  height: 100%;

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
  }
}
</style>
